import React, { useContext, useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
  IconButton,
  Divider,
  InputLabel,
  Grid,
  Stack
} from '@mui/material';
import { Close } from '@mui/icons-material';
import SidebarContext from './sidebarcontext/SidebarContext';
import CryptoJS from "crypto-js";

export const Alert = () => {
  const apisignature = process.env.REACT_APP_SIGNATURE;
  const userinfo = JSON.parse(localStorage.getItem("userInfo"));
  const context = useContext(SidebarContext);
  const {
    setAlert,
    setLogout,
    alert,
    setresetPassword,
    setMsg,
    url
  } = context;

  const initialValue = { OldPassword: '', NewPassword: '' };
  const [formValues, setFormValues] = useState(initialValue);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
    if (formErrors[name]) {
      setFormErrors({ ...formErrors, [name]: '' });
    }
  };

  const validate = (values) => {
    const errors = {};
    if (!values.NewPassword) {
      errors.NewPassword = "New Password is required";
    }
    if (!values.OldPassword) {
      errors.OldPassword = "Old Password is required";
    }
    return errors;
  };

  const fetchdata = async () => {
    const dataForm = {
      CoOperativeCode: userinfo.coOperativeCode,
      UserID: userinfo.UserID,
      IsMobUser: "N",
      OldPassWord: formValues.OldPassword,
      NewPassword: formValues.NewPassword,
      IsEncryptReq: "N",
      TimeStamp: new Date().toISOString()
    };

    var key = CryptoJS.enc.Utf8.parse("D89035A6634F4C4786B947518F17A18A");
    var iv = CryptoJS.enc.Utf8.parse("EasyS0ftS0ftware");

    var encrypted = CryptoJS.AES.encrypt(JSON.stringify(dataForm), key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    const dts = { EncrytedText: encrypted.toString() };

    try {
      const response = await fetch(`${url}/UserMgnt/ResetPassWord`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Signature: apisignature,
        },
        body: JSON.stringify(dts),
      });
      const pay = await response.json();

      setMsg({
        msg: pay.message,
        type: pay.statuS_CODE === "0" ? "success" : "error",
      });
    } catch {
      setMsg({
        msg: "An error occurred while changing password",
        type: "error",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate(formValues);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    if (isSubmit) {
      fetchdata();
      setIsSubmit(false);
    }
  }, [isSubmit]);

  const handleClose = () => {
    setFormValues(initialValue);
    setIsSubmit(false);
    setFormErrors({});
    setAlert({ fade: 'fade-default', msg: "", type: "" });
  };

  const logoutConfirm = () => {
    setLogout(true);
    sessionStorage.clear();
    localStorage.clear();
    handleClose();
  };

  const confirmReset = () => {
    setresetPassword(true);
    handleClose();
  };

  const renderAlertContent = () => {
    const headerStyle = {
      backgroundColor: 'primary.main',
      color: 'primary.contrastText',
      py: 1.5,
      px: 2,
    };

    switch (alert.type) {
      case "logout":
        return (
          <>
            <DialogTitle sx={headerStyle}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight={600}>Easy Software</Typography>
                <IconButton onClick={handleClose} size="small" sx={{ color: 'inherit' }}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <Typography variant="body1">{alert.msg}</Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button onClick={logoutConfirm} variant="contained" color="error">
                Logout
              </Button>
              <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
          </>
        );

      case "reset":
        return (
          <>
            <DialogTitle sx={headerStyle}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight={600}>Easy Software</Typography>
                <IconButton onClick={handleClose} size="small" sx={{ color: 'inherit' }}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ py: 3 }}>
              <Typography variant="body1">{alert.msg}</Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button onClick={confirmReset} variant="contained" color="primary">
                Reset Password
              </Button>
              <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
          </>
        );

      case "change":
        return (
          <>
            <DialogTitle sx={headerStyle}>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h6" fontWeight={600}>Change Password</Typography>
                <IconButton onClick={handleClose} size="small" sx={{ color: 'inherit' }}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
            <Divider />

            <DialogContent>
              <Box component="form" onSubmit={handleSubmit}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="OldPassword">Old Password<sup className="error">*</sup></InputLabel>
                      <TextField
                        fullWidth
                        type="password"
                        name="OldPassword"
                        value={formValues.OldPassword}
                        onChange={handleChange}
                        error={!!formErrors.OldPassword}
                        helperText={formErrors.OldPassword}
                        margin="normal"
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={12}>
                    <Stack spacing={1}>
                      <InputLabel htmlFor="NewPassword">New Password<sup className="error">*</sup></InputLabel>
                      <TextField
                        fullWidth
                        type="password"
                        name="NewPassword"
                        value={formValues.NewPassword}
                        onChange={handleChange}
                        error={!!formErrors.NewPassword}
                        helperText={formErrors.NewPassword}
                        margin="normal"
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
              <Button onClick={handleSubmit} variant="contained" color="primary">
                Change Password
              </Button>
              <Button onClick={handleClose} variant="outlined">Cancel</Button>
            </DialogActions>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Dialog
      open={!!alert.type}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: 6,
        }
      }}
    >
      {renderAlertContent()}
    </Dialog>
  );
};
